import type { ReactNode } from "react";
import { cn } from "./cn";

const baseHeading = "font-display italic font-extrabold tracking-tight leading-[1.05] m-0 [text-wrap:balance]";

export function H1({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <h1
      className={cn(
        baseHeading,
        "text-[clamp(40px,5.2vw,68px)] leading-[1.02] text-td-1 mt-6",
        className,
      )}
    >
      {children}
    </h1>
  );
}

export function H2({
  children,
  light,
  className,
}: {
  children: ReactNode;
  light?: boolean;
  className?: string;
}) {
  return (
    <h2
      className={cn(
        baseHeading,
        "text-[clamp(36px,4.6vw,64px)] mt-6",
        light ? "text-tl-1" : "text-td-1",
        className,
      )}
    >
      {children}
    </h2>
  );
}

export function H3({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <h3
      className={cn(
        "font-display italic font-bold leading-tight m-0 text-td-1",
        className,
      )}
    >
      {children}
    </h3>
  );
}

export function Highlight({
  children,
  light,
}: {
  children: ReactNode;
  light?: boolean;
}) {
  return <span className={light ? "text-accent-deep" : "text-accent"}>{children}</span>;
}
